import { CATEGORY_ROUTES as categoryRoutes } from "~/api/routes";

export const state = () => ({
  categories: null,
  details:null,
  image:null,
  isLoaded:false,
  close:false,
  isRequesting:false,
  categorie_id:-1,
  indexCat: -1,
  indexSelectCat: -1,
});

export const getters = {
  categorie_id : state =>{
    return state.categorie_id
  },
  indexCat : state =>{
    return state.indexCat
  },
  indexSelectCat : state =>{
    return state.indexSelectCat
  },
  productCategories: state =>{
    return state.categories? state.categories.filter( cat => {
      return cat.type === 'PRODUIT';
    }) : [];
  }
};

export const mutations = {
  SET_CATEGORY_ID(state,id){
    state.categorie_id = id;
  },
  SET_CATEGORY_INDEX(state,index){
    state.indexCat = index;
  },
  SET_CATEGORY_INDEX_SELECTED(state,index){
    state.indexSelectCat = index;
  },
  CATEGORIES_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.categories = [];
    //state.page = page;
  },
  CATEGORIES_SUCCES(state, categories) {
    state.categories = categories;
    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  CATEGORIES_ERROR(state) {
    state.categories = [];
    state.hasError = true;
  },
  CLOSE_MODAL(state,close){
    state.close = close;
  },
  IS_REQUESTING(state,isRequesting){
    state.isRequesting = isRequesting
  },
  CATEGORYS_LOADED(state) {
    //state.isLoading = false;
  },
  CATEGORY_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  CATEGORY_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  CATEGORY_SUCCES(state) {
    //state.isLoading = false;
  },
  CATEGORY_ERROR(state) {
    //state.isLoading = false;
  },
  UPDATE_A_CATEGORY(state, categorie) {
    let index = state.categories.findIndex((elem) => elem.categorie_id === categorie.categorie_id);
    state.categories = state.categories.filter(element => element.categorie_id !== categorie.categorie_id);
    state.categories.splice(index, 0, categorie);
  },
  ADD_CATEGORY_TO_LIST(state, category) {
    category.sous_categories = []; // so the state can delete a mutation in case we add a subcategory to this categoru
    state.categories.unshift(category);
  },
  ADD_SUB_CATEGORY(state, subCategory){
    state.categories = state.categories.map(cat =>{
      if (cat.categorie_id == subCategory.categorie_id){
        cat.sous_categories.push(subCategory);
      }
      return cat;
    });
  },
  UPDATE_SUB_CATEGORY(state, subCategory){
    state.categories = state.categories.map(cat =>{
      if (cat.categorie_id == subCategory.categorie_id){
        cat.sous_categories =  cat.sous_categories.map(sub =>{
          if (sub.sous_categorie_id == subCategory.sous_categorie_id)
              return subCategory;
          return sub;
        });
      }
      return cat;
    });
  },
  REMOVE_SUB_CATEGORY(state, params){
    state.categories = state.categories.map(cat =>{
      if (cat.categorie_id == params.categorie_id){
        cat.sous_categories =  cat.sous_categories.filter(sub =>{
          return sub.sous_categorie_id != params.id;
        });
      }
      return cat;
    });
  },
  SET_CATEGORY_IMAGE(state, image) {
    state.image=image;
  },
  REMOVE_CATEGORY_FROM_LIST(state, category) {
    state.categories = state.categories.filter(element => element.categorie_id !== category.categorie_id);
  },
  GET_CATEGORY_SUCCES(state, details) {
    state.details = details
    //state.isLoading = false;
  },
  REMOVE_CATEGORY_IMAGE(state, categorie_id) {
    let index = state.categories.findIndex((elem) => elem.categorie_id === categorie_id);
    state.categories[index].image=null
  },
  IS_LOADED(state,isLoaded){
    state.isLoaded = isLoaded
  }
};

export const actions = {
  setCategoryImage({ commit }, image){
    commit('SET_CATEGORY_IMAGE', image);
  },

  async getCategories({ commit }) {
    commit('CATEGORIES_LOAD');
    commit('IS_LOADED',false);
    this.$api.request(categoryRoutes.list)
      .then(response => {
        commit('CATEGORIES_SUCCES', response.payload);
      })
      .catch(error => {
        commit('CATEGORIES_ERROR');
      })
      .finally(() => {
        commit('IS_LOADED',true);
        commit('CATEGORYS_LOADED')
      });
  },

  async getCategory({commit}, params) {
    commit('CATEGORY_PROCESSING_START');
    await this.$api.request(categoryRoutes.get, {id: params.categorie_id})
      .then(response => {
        commit('GET_CATEGORY_SUCCES', response.payload);
      })
      .catch(error => {
        commit('CATEGORY_ERROR');
      })
      .finally(() => commit('CATEGORY_PROCESSING_END'));
  },

  async createCategory({ commit }, params) {
    commit('CATEGORY_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(categoryRoutes.create,{}, params.formData)
      .then(response => {
        commit('CLOSE_MODAL',true);
        commit('ADD_CATEGORY_TO_LIST', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('CATEGORY_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('CATEGORY_PROCESSING_END')
      });
  },

  async attachItemsCategory({ commit }, params) {
    commit('CATEGORY_PROCESSING_START');
    await this.$api.request(categoryRoutes.items.attach,{id: params.id}, params)
      .then(response => {
        //commit('', response);
        if(params.config === 'PRESTATION')
          this.dispatch('prestation/getPrestations');
        else
          this.dispatch('bonPlan/getBonplans');
      })
      .catch(error => {
        commit('CATEGORY_ERROR');
      })
      .finally(() => commit('CATEGORY_PROCESSING_END'));
  },

  async detachItemsCategory({ commit }, params) {
    commit('CATEGORY_PROCESSING_START');
    await this.$api.request(categoryRoutes.items.detach,{id: params.id}, params)
      .then(response => {
        //commit('', response);
        if(params.config === 'PRESTATION')
          this.dispatch('prestation/getPrestations');
        else
          this.dispatch('bonPlan/getBonplans');
      })
      .catch(error => {
        commit('CATEGORY_ERROR');
      })
      .finally(() => commit('CATEGORY_PROCESSING_END'));
  },


  async updateCategory({ commit }, params) {
    commit('CATEGORY_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(categoryRoutes.update, { id: params.id }, params.formData)
      .then(response => {
        commit('CATEGORY_SUCCES', response);
        commit('UPDATE_A_CATEGORY', response.payload);
        commit('CLOSE_MODAL',true);
      })
      .catch(error => {
        commit('CATEGORY_ERROR');
        commit('CLOSE_MODAL',false);
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('CATEGORY_PROCESSING_END')
      });
  },
  async deleteCategory({ commit }, params) {
    commit('CATEGORY_PROCESSING_START');
    await this.$api.request(categoryRoutes.delete, { id: params.categorie_id })
      .then(response => {
        commit('REMOVE_CATEGORY_FROM_LIST', response.payload);
      })
      .catch(error => {
        commit('CATEGORY_ERROR');
      })
      .finally(() => {
        commit('SET_CATEGORY_ID',-1);
        commit('SET_CATEGORY_INDEX',-1);
        commit('SET_CATEGORY_INDEX_SELECTED',-1);
        commit('CATEGORY_PROCESSING_END')
      });
  },
  async removeImage({ commit }, params){
    commit('REMOVE_CATEGORY_IMAGE', params.id);
  },
  async setCategoryId({commit},params){
    commit('SET_CATEGORY_ID',params)
  },
  async setCategoryIndex({commit},params){
    commit('SET_CATEGORY_INDEX',params)
  },
  async setCategoryIndexSelected({commit},params){
    commit('SET_CATEGORY_INDEX_SELECTED',params)
  },
  async createSubCategory({ commit }, params) {
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(categoryRoutes.subCategories.create,{}, params.formData)
      .then(response => {
        commit('CLOSE_MODAL',true);
        commit('ADD_SUB_CATEGORY', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('CATEGORY_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('CATEGORY_PROCESSING_END')
      });
  },
  async updateSubCategory({ commit }, params) {
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(categoryRoutes.subCategories.update,{id: params.id}, params.formData)
      .then(response => {
        commit('CLOSE_MODAL',true);
        commit('UPDATE_SUB_CATEGORY', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('CATEGORY_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('CATEGORY_PROCESSING_END')
      });
  },
  async deleteSubCategory({ commit }, params) {
    commit('CATEGORY_PROCESSING_START');
    await this.$api.request(categoryRoutes.subCategories.delete, { id: params.id})
      .then(response => {
        commit('REMOVE_SUB_CATEGORY', params);
        this.$toast.open({
          message: response._response.message,
          type: 'success',
          duration: 4500
        });
      })
      .catch(error => {
        this.$toast.open({
          message: error.response._response.message,
          type: 'error',
          duration: 4500
        });
        commit('CATEGORY_ERROR');
      })
      .finally(() => {
      });
  },
};
